import { render, staticRenderFns } from "./Checklist.vue?vue&type=template&id=7968ba5c&scoped=true&"
import script from "./Checklist.vue?vue&type=script&lang=js&"
export * from "./Checklist.vue?vue&type=script&lang=js&"
import style0 from "./Checklist.vue?vue&type=style&index=0&id=7968ba5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7968ba5c",
  null
  
)

export default component.exports